import {valueValidatableInitialize, valueValidatableClearance} from './valueValidatableInitialize';

const textInputInitialize = (RMI, contextId, compId) => valueValidatableInitialize(RMI, contextId, compId);

const textInputClearance = (RMI, contextId, compId) => valueValidatableClearance(RMI, contextId, compId);

export {textInputInitialize, textInputClearance};
